import { userContext } from 'Context/userContext';
import React, { useContext, useEffect } from 'react'
import { useState } from 'react';
import { useCallback } from 'react';
// import { getKabupaten } from 'services/apiRoutes';

export default function Kabupaten({ onChange, disabled, setValue,all }) {
  const dataContext = useContext(userContext);

  const [kab, setKab] = useState();

  const kabAPI = useCallback(async (e) => {
    // const res = await getKabupaten(e);
    // const { data } = res.data;
    // setKab(data);
  }, []);

  useEffect(() => {
    kabAPI(dataContext.prov);
  }, [dataContext.prov, kabAPI]);

  return (
    <div className="flex flex-col">
      <label htmlFor="kabupaten" className="m-2 text-sm font-semibold">
        Kabupaten
      </label>
      <select
        // defaultValue={defaultValue}
        value={setValue}
        disabled={disabled}
        onChange={onChange}
        name="kabupaten"
        className="px-3 py-3 mr-4 border seacrh rounded-2xl focus:ring-2 focus:ring-primary focus:border-none focus:outline-none"
      >
        <option key="yt673638" value="null" disabled={!all}>
          Semua Kabupaten
        </option>
        {kab?.map((e) => (
          <option key={e.kodeKabupaten} value={e.kodeKabupaten}>
            {e.namaKabupaten}
          </option>
        ))}
      </select>
    </div>
  );
}
